import OspreyApiHelper from './helper'

export default class OspreyUsers {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-users.js